import {PropsWithChildren, useState} from "react";
import {FiPlus} from "react-icons/fi";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {DropdownItem} from "@/components/dropdown/subComponents/DropdownItem/DropdownItem.tsx";
import {DropdownButtonGroup} from "@/components/dropdownButtonGroup/DropdownButtonGroup.tsx";
import {AddExternalUserModal} from "@/pages/statuspages/tabs/external-users/components/AddExternalUserModal.tsx";

import styles from "./AddExternalUserAction.module.scss";

interface AddExternalUserActionProps extends PropsWithChildren {
  statusPageID: number;
}

export const AddExternalUserAction = ({statusPageID}: AddExternalUserActionProps) => {
  const {brand} = useCurrentUserContext();
  const [show, setShow] = useState<boolean>(false);

  return (
    <>
      <DropdownButtonGroup
        onClick={() => {
          setShow(true);
        }}
        className={"text-nowrap"}
        title={"New External User"}
        toggleClassName={styles.externalUserActionToggle}
        icon={FiPlus}
      >
        <DropdownItem onClick={() => setShow(true)}>New External User</DropdownItem>
        <DropdownItem href={`${brand.siteURL}/statuspages/${statusPageID}/external-account-users/csv`}>
          Export to CSV
        </DropdownItem>
      </DropdownButtonGroup>
      {show && <AddExternalUserModal setShow={setShow} statusPageID={statusPageID} />}
    </>
  );
};
